const FlashIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M5.88591 13.228L13.6817 1.22021L11.4818 10.8974H18.114L10.3523 22.7797L12.6993 13.228H5.88591Z" stroke="currentColor" strokeLinejoin="round" />
        </svg>
    )
}
export default FlashIcon